module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-Nottingham-5867fd31c97d63a1cd398a29b056de27.svg";